export function generate_tile_id() {
  return 'ft6bcn_' + (+new Date).toString(36).slice(-10);
}